import {
  AppstoreAddOutlined,
  BranchesOutlined,
  DashboardOutlined,
  DesktopOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  FontSizeOutlined,
  GroupOutlined,
  HistoryOutlined,
  LineChartOutlined,
  MessageOutlined,
  MoneyCollectOutlined,
  SendOutlined,
  SettingOutlined,
  ShoppingOutlined,
  SolutionOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  AddOptionIcon,
  BillClockIcon,
  BrandWorkflowIcon,
  CalculatorIcon,
  CardBankIcon,
  ChartIcon,
  CheckListIcon,
  CheckWarehouseIcon,
  CookingProductIcon,
  CustomerIcon,
  DebtReportIcon,
  ExportWarehouseIcon,
  GroupIcon,
  IconHistory,
  ImportWarehouseIcon,
  InvoiceIcon,
  ManagerCustomerIcon,
  MaterialIcon,
  MaterialToolIcon,
  MegaPhone,
  NoticeIcon,
  OrderFeatureIcon,
  OtherOption,
  PrintingIcon,
  PurchaseOrderIcon,
  PurchaseReportIcon,
  QrIcon,
  SafetyIcon,
  SecondaryScreenIcon,
  SemiProductIcon,
  SettingsOtherPriceIcon,
  SettingViewProduct,
  SolarCartIcon,
  StarPointIcon,
  StoreIcon,
  SubscriptionIcon,
  TagsIcon,
  TreeIcon,
  UnitIcon,
  VoucherIcon,
  WarehouseIcon,
} from "assets/svg/icon";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { WORKSPACES } from "constanst";
import { SYSTEM_ROLES } from "constants/AuthConstant";

const dashBoardNavTree = [
  {
    key: "dashboards",
    path: `${APP_PREFIX_PATH}/dashboards`,
    title: "sidenav.dashboard",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.WarehouseEmployee],
    submenu: [
      {
        key: "dashboards-report-partner",
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        title: "sidenav.dashboard.report",
        icon: ChartIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.WarehouseEmployee],
        workspace: [WORKSPACES.BRANCH],
        permission: ["report_quick_branch.view"],
      },
      {
        key: "dashboards-report-partner-company",
        path: `${APP_PREFIX_PATH}/dashboards/mergeReport`,
        title: "sidenav.dashboard.mergeReport",
        icon: ChartIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.WarehouseEmployee],
        workspace: [WORKSPACES.COMPANY],
        permission: ["report_consolidated.view"],
      },
      {
        key: "report-detail",
        path: `${APP_PREFIX_PATH}/report-detail`,
        title: "sidenav.admin.detailReports",
        icon: FileTextOutlined,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.PurchasingEmployee],
        workspace: [WORKSPACES.BRANCH, WORKSPACES.COMPANY],
        permission: ["report_detail_company.view", "report_detail_branch.view"],
      },
    ],
  },
];

const dashBoardAccountNavTree = [
  {
    key: "dashboardsAccount",
    path: `${APP_PREFIX_PATH}/dashboardsAccount`,
    title: "sidenav.dashboard",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin],
    submenu: [
      {
        key: "dashboards-account",
        path: `${APP_PREFIX_PATH}/dashboardsAccount/default`,
        title: "sidenav.dashboard.dashboardAccount",
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "dashboards-saas",
        path: `${APP_PREFIX_PATH}/dashboardsAccount/saas`,
        title: "sidenav.dashboard.saas",
        icon: MoneyCollectOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
    ],
  },
];

const operationNavTree = [
  {
    key: "operation",
    path: `${APP_PREFIX_PATH}/dashboards`,
    title: "VẬN HÀNH",
    icon: DashboardOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [
      SYSTEM_ROLES.PartnerAdmin,
      SYSTEM_ROLES.StoreAdmin,
      SYSTEM_ROLES.AccountantEmployee,
      SYSTEM_ROLES.PurchasingEmployee,
      SYSTEM_ROLES.WarehouseEmployee,
    ],
    submenu: [
      {
        key: "manager-table",
        path: `${APP_PREFIX_PATH}/manager/table`,
        title: "sidenav.manager.table",
        icon: QrIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.BRANCH],
        permission: ["table_qr.view"],
      },
      {
        key: "manager-order",
        path: `${APP_PREFIX_PATH}/manager/order`,
        title: "sidenav.manager.order",
        icon: BillClockIcon,
        breadcrumb: true,
        submenu: [],
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
        ],
        workspace: [WORKSPACES.BRANCH],
        permission: ["order_history.view"],
      },
      {
        key: "history",
        path: `${APP_PREFIX_PATH}/manager/history`,
        title: "sidenav.manager.history",
        breadcrumb: false,
        submenu: [],
        icon: IconHistory,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.BRANCH],
        permission: ["activity_log_branch.view"],
      },
    ],
  },
];

const saasManager = [
  {
    key: "saasManager",
    path: `${APP_PREFIX_PATH}/saas`,
    title: "sidenav.saas",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin],
    submenu: [
      {
        key: "saasSetting",
        path: `${APP_PREFIX_PATH}/saas/setting`,
        title: "sidenav.saas.setting",
        icon: ShoppingOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "saasHistory",
        path: `${APP_PREFIX_PATH}/saas/history`,
        title: "sidenav.saas.history",
        icon: HistoryOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
    ],
  },
];

const affiliateManager = [
  {
    key: "affiliateManager",
    path: `${APP_PREFIX_PATH}/affiliate`,
    title: "sidenav.affiliate",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin],
    submenu: [
      {
        key: "affiliateSetting",
        path: `${APP_PREFIX_PATH}/affiliate/setting`,
        title: "sidenav.affiliate.setting",
        icon: BranchesOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "affiliatePersonal",
        path: `${APP_PREFIX_PATH}/affiliate/personal`,
        title: "sidenav.affiliate.personal",
        icon: UserAddOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "affiliateAgency",
        path: `${APP_PREFIX_PATH}/affiliate/agency`,
        title: "sidenav.affiliate.agency",
        icon: UsergroupAddOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
    ],
  },
];

const cmsManager = [
  {
    key: "cmsManager",
    path: `${APP_PREFIX_PATH}/cms`,
    title: "sidenav.marketing",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
    submenu: [
      {
        key: "manager-post",
        path: `${APP_PREFIX_PATH}/manager/post`,
        title: "sidenav.manager.post",
        icon: MegaPhone,
        breadcrumb: true,
        submenu: [],
        roles:[SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.OperatorAdmin],
        workspace: [WORKSPACES.BRANCH],
        permission: ["cms_post_branch.view"],
      },
      {
        key: "admin-settings-store-banner",
        path: `${APP_PREFIX_PATH}/admin/settings/store-banner`,
        title: "sidenav.admin.settings.banner",
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "admin-settings-report-violation",
        path: `${APP_PREFIX_PATH}/admin/settings/report-violation`,
        title: "sidenav.admin.report-violation",
        icon: FileExcelOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "admin-settings-word-violation",
        path: `${APP_PREFIX_PATH}/admin/settings/word-violation`,
        title: "sidenav.admin.word-violation",
        icon: FontSizeOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "manager-customer",
        path: `${APP_PREFIX_PATH}/manager/customer`,
        title: "sidenav.manager.customer",
        icon: CustomerIcon,
        breadcrumb: true,
        submenu: [],
        workspace: [WORKSPACES.BRANCH],
        permission: ["customer_management_branch.view"],
      },
    ],
  },
];

const managerNavtree = [
  {
    key: "manager",
    path: `${APP_PREFIX_PATH}/manager`,
    title: "Tổ chức & Nhân sự",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [
      SYSTEM_ROLES.PartnerAdmin,
      SYSTEM_ROLES.StoreAdmin,
      SYSTEM_ROLES.OperatorAdmin,
      SYSTEM_ROLES.AccountantEmployee,
      SYSTEM_ROLES.PurchasingEmployee,
      SYSTEM_ROLES.WarehouseEmployee,
    ],
    submenu: [
      {
        key: "smenu-partner",
        path: `${APP_PREFIX_PATH}/manager/partner`,
        title: "sidenav.manager.partner",
        icon: SolutionOutlined,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "manager-restaurant",
        path: `${APP_PREFIX_PATH}/manager/restaurant`,
        title: "sidenav.manager.restaurant",
        icon: StoreIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["branch_management.view"],
      },
      {
        key: "manager-organization-structure",
        path: `${APP_PREFIX_PATH}/manager/organization-structure`,
        title: "sidenav.manager.organization-structure",
        icon: TreeIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["org_structure.view"],
      },
      // {
      //   key: "manager-product",
      //   path: `${APP_PREFIX_PATH}/manager/product`,
      //   title: "sidenav.manager.product",
      //   icon: ProductIcon,
      //   breadcrumb: true,
      //   submenu: [],
      //   roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.WarehouseEmployee]
      // },

      {
        key: "manager-employee",
        path: `${APP_PREFIX_PATH}/manager/employee`,
        title: "sidenav.manager.employee",
        icon: GroupIcon,
        breadcrumb: true,
        submenu: [],
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.PurchasingEmployee,
        ],
        workspace: [WORKSPACES.COMPANY, WORKSPACES.BRANCH],
        permission: ["staff_directory.view", "branch_staff_view.view"],
      },
      {
        key: "manager-role-permission",
        path: `${APP_PREFIX_PATH}/manager/role-permission`,
        title: "sidenav.manager.role-permission",
        icon: SafetyIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["role_permission.view"],
      },
      {
        key: "history",
        path: `${APP_PREFIX_PATH}/manager/history`,
        title: "sidenav.manager.history",
        breadcrumb: false,
        submenu: [],
        icon: IconHistory,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.COMPANY],
        permission: ["activity_log_company.view"],
      },
      {
        key: "manager-subscription",
        path: `${APP_PREFIX_PATH}/manager/subscription`,
        title: "sidenav.manager.subscription",
        icon: SubscriptionIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["subscription.view"],
      },
      // {
      //   key: "manager-order",
      //   path: `${APP_PREFIX_PATH}/manager/order`,
      //   title: "sidenav.manager.order",
      //   icon: BillClockIcon,
      //   breadcrumb: true,
      //   submenu: [],
      //   roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.AccountantEmployee]
      // },
      // {
      //   key: "manager-diners",
      //   path: `${APP_PREFIX_PATH}/manager/diners`,
      //   title: "sidenav.manager.diners",
      //   icon: TeamOutlined,
      //   breadcrumb: true,
      //   submenu: [],
      //   roles:[SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin]
      // },
      {
        key: "smenu-app-account",
        path: `${APP_PREFIX_PATH}/manager/appaccount`,
        title: "sidenav.manager.app-account",
        icon: UserOutlined,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      // {
      //   key: "manager-notification",
      //   path: `${APP_PREFIX_PATH}/manager/notification/noti`,
      //   title: "sidenav.manager.notification",
      //   icon: TeamOutlined,
      //   breadcrumb: true,
      //   submenu: [],
      // },
    ],
  },
];

const sellNavtree = [
  {
    key: "sell",
    path: `${APP_PREFIX_PATH}/sell`,
    title: "sidenav.sell",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.StoreEmployee, SYSTEM_ROLES.KitchenEmployee, SYSTEM_ROLES.AccountantEmployee],
    submenu: [
      {
        key: "smenu-partner",
        path: `${APP_PREFIX_PATH}/sell/pos`,
        title: "sidenav.sell.pos",
        icon: DesktopOutlined,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.StoreEmployee, SYSTEM_ROLES.KitchenEmployee, SYSTEM_ROLES.AccountantEmployee],
      },
    ],
  },
];

const workTree = [
  {
    key: "work",
    path: `${APP_PREFIX_PATH}/manager`,
    title: "brandNav.settingAndWork",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    workspace: [WORKSPACES.COMPANY],
    roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.StoreEmployee, SYSTEM_ROLES.KitchenEmployee, SYSTEM_ROLES.AccountantEmployee],
    submenu: [
      {
        key: "brand-workflow",
        path: `${APP_PREFIX_PATH}/manager/brand-workflow`,
        title: "brandNav.workflow",
        icon: BrandWorkflowIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["brand_workflow.view"],
      },
      {
        key: "order-feature",
        path: `${APP_PREFIX_PATH}/manager/order-features`,
        title: "brandNav.orderFeatures",
        icon: OrderFeatureIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["order_features.view"],
      },
      {
        key: "printing-setting",
        path: `${APP_PREFIX_PATH}/manager/printing`,
        title: "brandNav.printing",
        icon: PrintingIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["print_template.view"],
      },
      {
        key: "product-display-setting",
        path: `${APP_PREFIX_PATH}/manager/product-display`,
        title: "brandNav.productDisplay",
        icon: SettingViewProduct,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["product_display_settings.view"],
      },
    ],
  },
];

const marketingAndSupportCustomer = [
  {
    key: "marketing-support-customer",
    path: `${APP_PREFIX_PATH}/admin/manager`,
    title: "sidenav.admin.marketing",
    icon: SettingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
    submenu: [
      {
        key: "manager-post",
        path: `${APP_PREFIX_PATH}/manager/post`,
        title: "sidenav.manager.post",
        icon: NoticeIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["cms_post_company.view"],
      },
      {
        key: "admin-calculate-loyalty",
        path: `${APP_PREFIX_PATH}/admin/manager/calculate-loyalty`,
        title: "brandNav.loyalty",
        icon: StarPointIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["loyalty_points.view"],
      },
      {
        key: "admin-voucher-price",
        path: `${APP_PREFIX_PATH}/admin/manager/voucher-price`,
        title: "brandNav.vouchers",
        icon: VoucherIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["voucher_campaign.view"],
      },
      {
        key: "admin-secondary-screen",
        path: `${APP_PREFIX_PATH}/admin/manager/secondary-screen`,
        title: "brandNav.secondaryScreen",
        icon: SecondaryScreenIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["secondary_screen.view", "voucher_campaign.view"],
      },
      {
        key: "manager-customer",
        path: `${APP_PREFIX_PATH}/manager/customer`,
        title: "sidenav.manager.customer",
        icon: ManagerCustomerIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["customer_management_company.view"],
      },
    ],
  },
];

const priceAndAccountant = [
  {
    key: "accountant-settings",
    path: `${APP_PREFIX_PATH}/admin/settings`,
    title: "sidenav.admin.settings",
    icon: SettingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
    submenu: [
      {
        key: "admin-settings-payment-account",
        path: `${APP_PREFIX_PATH}/admin/settings/payment-account`,
        title: "brandNav.paymentAccount",
        icon: CardBankIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["branch_payment_account.view"],
      },
      {
        key: "admin-settings-extra-costs",
        path: `${APP_PREFIX_PATH}/admin/settings/extra-costs`,
        title: "brandNav.extraCosts",
        icon: SettingsOtherPriceIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["other_fee_settings.view"],
      },
      {
        key: "admin-settings-invoice",
        path: `${APP_PREFIX_PATH}/admin/settings/electronic-invoice`,
        title: "sidenav.admin.settings.invoice",
        icon: InvoiceIcon,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["e_invoice.view"],
      },
      {
        key: "integration-misa",
        path: `${APP_PREFIX_PATH}/integrations/misa`,
        title: "sidenav.admin.integrations.misa",
        icon: CalculatorIcon,
        breadcrumb: true,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
        workspace: [WORKSPACES.COMPANY],
        permission: ["accounting_software.view"],
      },
    ],
  },
];

const adminNavTree = [
  {
    key: "admin-settings",
    path: `${APP_PREFIX_PATH}/admin/settings`,
    title: "sidenav.admin.settings",
    icon: SettingOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin],
    submenu: [
      {
        key: "admin-settings-rating-cate",
        path: `${APP_PREFIX_PATH}/admin/settings/rating-category`,
        title: "sidenav.admin.settings.rating-categories",
        icon: SendOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "admin-settings-group-cate",
        path: `${APP_PREFIX_PATH}/admin/settings/group-category`,
        title: "sidenav.admin.settings.group-categories",
        icon: GroupOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "admin-settings-store-cate",
        path: `${APP_PREFIX_PATH}/admin/settings/store-categories`,
        title: "sidenav.admin.settings.store-categories",
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      {
        key: "admin-settings-store-utilities",
        path: `${APP_PREFIX_PATH}/admin/settings/store-utilities`,
        title: "sidenav.admin.settings.store-utilities",
        icon: AppstoreAddOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
      // {
      //   key: "admin-settings-menu-cate",
      //   path: `${APP_PREFIX_PATH}/admin/settings/menu-categories`,
      //   title: "sidenav.admin.settings.menu-categories",
      //   icon: SettingOutlined,
      //   breadcrumb: false,
      //   submenu: [],
      //   roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin]
      // },
      {
        key: "admin-settings-smenubookAI",
        path: `${APP_PREFIX_PATH}/admin/settings/ai`,
        title: "sidenav.admin.settings.smenubook-ai",
        icon: MessageOutlined,
        breadcrumb: false,
        submenu: [],
        roles: [SYSTEM_ROLES.OperatorAdmin],
      },
    ],
  },
];

const purchaseManager = [
  {
    key: "purchaseManager",
    path: `${APP_PREFIX_PATH}/manager`,
    title: "sidenav.manager.purchase",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.WarehouseEmployee],
    submenu: [
      {
        key: "request-order",
        path: `${APP_PREFIX_PATH}/manager/request-order`,
        title: "sidenav.manager.purchase.requestOrder",
        breadcrumb: false,
        submenu: [],
        icon: SolarCartIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        isRequestOrder: true,
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["ro_purchasing.view", "ro_branch.view"],
      },
      {
        key: "purchase-order",
        path: `${APP_PREFIX_PATH}/manager/purchase-order`,
        title: "sidenav.manager.purchase.purchaseOrder",
        breadcrumb: false,
        submenu: [],
        icon: PurchaseOrderIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        isPurchaseOrder: true,
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["po_purchasing.view", "po_branch.view"],
      },
      {
        key: "supplier-price",
        path: `${APP_PREFIX_PATH}/manager/supplier-price`,
        title: "sidenav.manager.purchase.supplierPrice",
        breadcrumb: false,
        submenu: [],
        icon: DebtReportIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.PurchasingEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["supplier_management.view", "supplier_management_branch.view"],
      },
      {
        key: "purchase-report",
        path: `${APP_PREFIX_PATH}/manager/purchase-report`,
        title: "sidenav.manager.purchase.purchaseReport",
        breadcrumb: false,
        submenu: [],
        icon: PurchaseReportIcon,
        roles: [SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.PurchasingEmployee],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["purchase_report_debt.view"],
      },
    ],
  },
];

const warehouseManager = [
  {
    key: "warehouseManager",
    path: `${APP_PREFIX_PATH}/manager`,
    title: "sidenav.manager.warehouse",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.WarehouseEmployee],
    submenu: [
      {
        key: "warehouse",
        path: `${APP_PREFIX_PATH}/manager/warehouse`,
        title: "sidenav.manager.warehouse.manage",
        breadcrumb: false,
        submenu: [],
        icon: WarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["inventory_summary_purchasing.view"],
      },
      {
        key: "import-material",
        path: `${APP_PREFIX_PATH}/manager/import`,
        title: "sidenav.manager.warehouse.import",
        breadcrumb: false,
        submenu: [],
        icon: ImportWarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["goods_receipt_purchasing.view", "goods_receipt_transfer_purchasing.view"],
      },
      {
        key: "transfer-material",
        path: `${APP_PREFIX_PATH}/manager/transfer`,
        title: "sidenav.manager.warehouse.transfer",
        breadcrumb: false,
        submenu: [],
        icon: ExportWarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["goods_issue_purchasing.view", "goods_issue_transfer_purchasing.view"],
      },
      {
        key: "warehouse-check",
        path: `${APP_PREFIX_PATH}/manager/check`,
        title: "sidenav.manager.warehouse.check",
        breadcrumb: false,
        submenu: [],
        icon: CheckWarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["stock_count_purchasing.view"],
      },
    ],
  },
];

const warehouseBranchManager = [
  {
    key: "warehouseManagerBranch",
    path: `${APP_PREFIX_PATH}/manager`,
    title: "sidenav.manager.warehouse.branch",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.WarehouseEmployee],
    submenu: [
      {
        key: "warehouse",
        path: `${APP_PREFIX_PATH}/manager/warehouse`,
        title: "sidenav.manager.warehouse.manage",
        breadcrumb: false,
        submenu: [],
        icon: WarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.BRANCH],
        permission: ["inventory_summary_branch.view"],
      },
      {
        key: "import-material",
        path: `${APP_PREFIX_PATH}/manager/import`,
        title: "sidenav.manager.warehouse.import",
        breadcrumb: false,
        submenu: [],
        icon: ImportWarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.BRANCH],
        permission: ["goods_receipt_branch.view", "goods_receipt_transfer_branch.view"],
      },
      {
        key: "transfer-material",
        path: `${APP_PREFIX_PATH}/manager/transfer`,
        title: "sidenav.manager.warehouse.transfer",
        breadcrumb: false,
        submenu: [],
        icon: ExportWarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.BRANCH],
        permission: ["goods_issue_branch.view", "goods_issue_transfer_branch.view"],
      },
      {
        key: "warehouse-check",
        path: `${APP_PREFIX_PATH}/manager/check`,
        title: "sidenav.manager.warehouse.check",
        breadcrumb: false,
        submenu: [],
        icon: CheckWarehouseIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.BRANCH],
        permission: ["stock_count_branch.view"],
      },
    ],
  },
];

const materialProductNavTree = [
  {
    key: "materialProduct",
    path: `${APP_PREFIX_PATH}/manager`,
    title: "sidenav.manager.materialProduct",
    icon: UserOutlined,
    breadcrumb: false,
    isGroupTitle: true,
    roles: [SYSTEM_ROLES.OperatorAdmin, SYSTEM_ROLES.PartnerAdmin, SYSTEM_ROLES.StoreAdmin, SYSTEM_ROLES.PurchasingEmployee, SYSTEM_ROLES.AccountantEmployee, SYSTEM_ROLES.WarehouseEmployee],
    submenu: [
      {
        key: "cooking-product",
        path: `${APP_PREFIX_PATH}/manager/cooking-product`,
        title: "sidenav.manager.product.cooking",
        breadcrumb: false,
        submenu: [],
        icon: CookingProductIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["product_finished_purchasing.view", "product_finished_branch.view"],
      },
      {
        key: "semi-product",
        path: `${APP_PREFIX_PATH}/manager/semi-product`,
        title: "sidenav.manager.product.semi",
        breadcrumb: false,
        submenu: [],
        icon: SemiProductIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["product_finished_purchasing.view", "product_finished_branch.view"],
      },
      {
        key: "material",
        path: `${APP_PREFIX_PATH}/manager/material`,
        title: "sidenav.manager.material",
        breadcrumb: false,
        submenu: [],
        icon: MaterialIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["raw_material_purchasing.view", "raw_material_branch.view"],
      },
      {
        key: "material-tool",
        path: `${APP_PREFIX_PATH}/manager/material-tool`,
        title: "sidenav.manager.material-tool",
        breadcrumb: false,
        submenu: [],
        icon: MaterialToolIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["raw_material_purchasing.view", "raw_material_branch.view"],
      },
      {
        key: "warehouse-product",
        path: `${APP_PREFIX_PATH}/manager/warehouse-product`,
        title: "sidenav.manager.product.warehouse",
        breadcrumb: false,
        submenu: [],
        icon: CheckListIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING, WORKSPACES.BRANCH],
        permission: ["goods_resale_purchasing.view", "goods_resale_branch.view"],
      },
      {
        key: "categories",
        path: `${APP_PREFIX_PATH}/manager/categories`,
        title: "sidenav.manager.categories",
        breadcrumb: false,
        submenu: [],
        icon: TagsIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["product_group.view"],
      },
      {
        key: "unit",
        path: `${APP_PREFIX_PATH}/manager/units`,
        title: "sidenav.manager.units",
        breadcrumb: false,
        submenu: [],
        icon: UnitIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["unit_of_measure.view"],
      },
      {
        key: "add-option",
        path: `${APP_PREFIX_PATH}/manager/add-options`,
        title: "sidenav.manager.add-options",
        breadcrumb: false,
        submenu: [],
        icon: AddOptionIcon,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["product_addon_option.view"],
      },
      {
        key: "other-option",
        path: `${APP_PREFIX_PATH}/manager/other-options`,
        title: "sidenav.manager.other-options",
        breadcrumb: false,
        submenu: [],
        icon: OtherOption,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["product_other_option.view"],
      },
      {
        key: "history",
        path: `${APP_PREFIX_PATH}/manager/history`,
        title: "sidenav.manager.history",
        breadcrumb: false,
        submenu: [],
        icon: IconHistory,
        roles: [
          SYSTEM_ROLES.PartnerAdmin,
          SYSTEM_ROLES.StoreAdmin,
          SYSTEM_ROLES.AccountantEmployee,
          SYSTEM_ROLES.PurchasingEmployee,
          SYSTEM_ROLES.WarehouseEmployee,
        ],
        workspace: [WORKSPACES.PURCHASING],
        permission: ["activity_log_purchasing.view"],
      },
    ],
  },
];

const navigationConfig = [
  ...dashBoardNavTree,
  ...dashBoardAccountNavTree,
  ...operationNavTree,
  // ...sellNavtree,
  ...managerNavtree,
  ...purchaseManager,
  ...warehouseManager,
  ...workTree,
  ...marketingAndSupportCustomer,
  ...warehouseBranchManager,
  ...materialProductNavTree,
  ...saasManager,
  ...affiliateManager,
  ...cmsManager,
  ...priceAndAccountant,
  ...adminNavTree,
];

export default navigationConfig;
